enum NumberFormatType {
  NUMERIC = "numeric",
  NUMERIC_NO_COMMA = "numericNoComma",
  PERCENTAGE = "percentage",
}

export default NumberFormatType;
